import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const addRatingQuestionService = async (ratingData: any) =>
  handleApiCall(() => ApiService.post(apiRoutes.rating, ratingData));

export const getRatingService = async () =>
  handleApiCall(() => ApiService.get(apiRoutes.rating));

export const deleteRatingQuestionByIdService = async (id: string) =>
  handleApiCall(() =>
    ApiService.delete(apiRoutes.ratingById.replace(":questionId", id))
  );

export const editRatingQuestionService = async (id: string, ratingData: any) =>
  handleApiCall(() =>
    ApiService.put(apiRoutes.ratingById.replace(":questionId", id), ratingData)
  );

export const rateLessonService = async (id: string, ratingData: any) =>
  handleApiCall(() =>
    ApiService.post(apiRoutes.rateLesson.replace(":lessonId", id), ratingData)
  );

export const sendLessonFeedbackService = async (data: any) =>
  handleApiCall(() => ApiService.post(apiRoutes.lessonFeedback, data));
